import CustomDomainsSettings from './custom-domains-settings';

export default CustomDomainsSettings;
